import styled from 'styled-components';
import media from 'styled-media-query';
import React from "react";
import BackgroundImage from 'gatsby-background-image';

export const  BackgroundImg = styled(BackgroundImage)`
  &::before {
    box-shadow: rgba(0, 0, 0, 0.55) 0px 0px 0px 100vw inset; /* dark overlay */
    opacity: 1 !important;
  }

  }
`;


